import api from '../../utils/api';
import { Dispatch } from 'redux';
import { setDepartments } from '../reducers/department';

export const getDepartments = () => async (dispatch: Dispatch) => {
  return await api
    .getDepartmentsAsync()
    .then((res) => {
      dispatch(setDepartments(res));
    })
    .catch((err) => {
      throw err;
    });
};

export const getDepartmentsByHospital = (hspCd: string) => async (dispatch: Dispatch) => {
  try {
    const res = await api.getDepartmentsByHospitalAsync(hspCd);
    dispatch(setDepartments(res));
  } catch (err) {
    console.error("부서 불러오기 실패:", err);
    throw err;
  }
};


